import { FixedPage } from "../components/FixedPage/FixedPage";
import { SupportMain } from "./SupportMain";

interface SupportFixedProps {
  is_active: boolean;
  set_is_active: (is_active: boolean) => void;
}

export const SupportFixed = ({
  is_active,
  set_is_active,
}: SupportFixedProps) => {
  return (
    <FixedPage is_active={is_active} set_is_active={set_is_active}>
      <SupportMain></SupportMain>
    </FixedPage>
  );
};
